// Home.js または Home.tsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import About from "../components/About";
import Contact from "../components/Contact";
import Hero from "../components/Hero";
import Skill from "../components/Skill";
import Works from "../components/Works";
import { useHeaderNavigationContext } from "../context/HeaderNavigationContext";

const Home = () => {
  const { pathname } = useLocation();
  const { sectionId, setSectionId } = useHeaderNavigationContext();

  useEffect(() => {
    if (sectionId && pathname === "/") {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        setSectionId("");
      }
    }
  }, [pathname, sectionId, setSectionId]);
  return (
    <>
      <Hero />

      <Works />
      <Skill />
      <About />
      <Contact />
    </>
  );
};

export default Home;
